export const HEADER_SIGNIN_VIEW = 'signin'; // TODO Matt: Is this used anywhere?
export const HEADER_ONBOARDING_VIEW = 'onboarding';
export const HEADER_DASHBOARD_VIEW = 'dashboard';
export const DEFAULT_HEADER_MEETING_VIEW = 'meeting';
